import { api_GET, api_POST_Unauthorize, api_POST, api_PUT } from "./_api.js";

const usuario_api = {
  authenticateMunicipe: (login = { username: "", password: "" }) => {
    const promise = new Promise((resolve, reject) => {
      api_POST_Unauthorize(`authenticate/municipe`, login)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  authenticateRestrito: (login = { username: "", password: "" }) => {
    const promise = new Promise((resolve, reject) => {
      api_POST_Unauthorize(`authenticate/restrito`, login)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  esqueceuSenhaRestrito: (email) => {
    const promise = new Promise((resolve, reject) => {
      api_POST_Unauthorize(`authenticate/EsqueceuSenhaRestrito`, email)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  esqueceuSenhaMunicipe: (email) => {
    const promise = new Promise((resolve, reject) => {
      api_POST_Unauthorize(`authenticate/EsqueceuSenhaMunicipe`, email)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  trocarSenhaRestrito: (json) => {
    const promise = new Promise((resolve, reject) => {
      api_POST(`Authenticate/TrocarSenhaRestrito`, json)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  trocarSenhaMunicipe: (json) => {
    const promise = new Promise((resolve, reject) => {
      api_POST(`Authenticate/TrocarSenhaMunicipe`, json)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  getList: () => {
    const promise = new Promise((resolve, reject) => {
      api_GET(`Usuario`)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  getItem: (id) => {
    const promise = new Promise((resolve, reject) => {
      api_GET(`Usuario/GetItem/${id}`)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  getFuncionalidades: () => {
    const promise = new Promise((resolve, reject) => {
      api_GET(`Usuario/GetFuncionalidades/`)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  post: (json) => {
    const promise = new Promise((resolve, reject) => {
      api_POST("Usuario", json)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  put: (usuario) => {
    const promise = new Promise((resolve, reject) => {
      api_PUT("Usuario", usuario)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  PostPermissoes: (id, funcionalidadeAcos) => {
    const promise = new Promise((resolve, reject) => {
      api_POST(`Usuario/PostPermissoes/${id}`, funcionalidadeAcos)
        .then(result => {
          resolve(result)
        })
        .catch(result => reject(result));
    });
    return promise;
  }
}

export default usuario_api;
